import { render, staticRenderFns } from "./popupCalNovoValor.vue?vue&type=template&id=3e4fe357"
import script from "./popupCalNovoValor.vue?vue&type=script&lang=js"
export * from "./popupCalNovoValor.vue?vue&type=script&lang=js"
import style0 from "./popupCalNovoValor.vue?vue&type=style&index=0&id=3e4fe357&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports